// combatpro/panels/MonsterPanel.js
//
// Combat PRO - MonsterPanel (decomposition shell).
//
// MonsterPanel was a single large static extraction of the view-monsters
// section. Its markup has been decomposed verbatim into small components under
// panels/monsters/ (see monsters.keep.js). This file is now a thin shell that
// renders MonsterWorkspace, which composes those components and reproduces the
// original DOM exactly. No markup is duplicated here.
//
// The public surface is unchanged: MonsterPanel is still the default export and
// still renders the same view-monsters DOM, so CombatProEngineApp.js continues
// to use <MonsterPanel /> with no change.
//
// Imports only React and MonsterWorkspace. No state, hooks, handlers, logic, or
// calculations. Do not edit battletracker.html.

import React from 'react';
import MonsterWorkspace from './monsters/MonsterWorkspace';

function MonsterPanel() {
  return <MonsterWorkspace />;
}

export default MonsterPanel;
